function getScrollLeftForDrag(startScrollLeft, startPointerX, currentPointerX) {
  return startScrollLeft - (currentPointerX - startPointerX);
}

function getIsDragPastThreshold(startPointerX, currentPointerX) {
  const dragThresholdPixels = 5;

  return Math.abs(currentPointerX - startPointerX) > dragThresholdPixels;
}

function getIsScrollable(scrollWidth, clientWidth) {
  return scrollWidth > clientWidth;
}

const PAGE_COMMIT_RATIO = 0.3;

const SETTLE_TOLERANCE_PIXELS = 2;

function getPagesForRelease(travelledPixels, pageWidth) {
  if (pageWidth <= 0) return 0;

  const pagesTravelled = travelledPixels / pageWidth;

  if (pagesTravelled >= 0) return Math.floor(pagesTravelled + 1 - PAGE_COMMIT_RATIO);

  return Math.ceil(pagesTravelled - 1 + PAGE_COMMIT_RATIO);
}

function getScrollLeftForRelease(startScrollLeft, currentScrollLeft, pageWidth, maxScrollLeft) {
  const pagesCommitted = getPagesForRelease(currentScrollLeft - startScrollLeft, pageWidth);
  const targetScrollLeft = startScrollLeft + pagesCommitted * pageWidth;

  return Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));
}

function initDragScroll(scrollerElement) {
  if (scrollerElement.dataset.klDragScrollReady === 'true') return;

  scrollerElement.dataset.klDragScrollReady = 'true';

  const isPaged = scrollerElement.hasAttribute('data-kl-drag-scroll-paged');

  let startPointerX = 0;
  let startScrollLeft = 0;
  let isDragging = false;
  let hasDragged = false;

  let settleTargetScrollLeft = null;

  function endSettle() {
    if (settleTargetScrollLeft === null) return;

    settleTargetScrollLeft = null;
    scrollerElement.classList.remove('is-settling');
  }

  function settleOnPage() {
    const maxScrollLeft = scrollerElement.scrollWidth - scrollerElement.clientWidth;
    const targetScrollLeft = getScrollLeftForRelease(
      startScrollLeft,
      scrollerElement.scrollLeft,
      scrollerElement.clientWidth,
      maxScrollLeft
    );

    if (Math.abs(targetScrollLeft - scrollerElement.scrollLeft) <= SETTLE_TOLERANCE_PIXELS) return;

    settleTargetScrollLeft = targetScrollLeft;
    scrollerElement.classList.add('is-settling');

    const isReducedMotionPreferred = matchMedia('(prefers-reduced-motion: reduce)').matches;

    try {
      scrollerElement.scrollTo({
        left: targetScrollLeft,
        behavior: isReducedMotionPreferred ? 'auto' : 'smooth',
      });
    } catch (error) {
      console.debug('kl-drag-scroll: could not glide the row onto a page', { targetScrollLeft, error });
      endSettle();
    }
  }

  function endDrag() {
    if (!isDragging) return;

    isDragging = false;

    if (hasDragged && isPaged) settleOnPage();

    scrollerElement.classList.remove('is-dragging');
  }

  if (isPaged) {
    scrollerElement.addEventListener(
      'scroll',
      () => {
        if (settleTargetScrollLeft === null) return;
        if (Math.abs(scrollerElement.scrollLeft - settleTargetScrollLeft) > SETTLE_TOLERANCE_PIXELS) return;

        endSettle();
      },
      { passive: true }
    );

    if ('onscrollend' in scrollerElement) {
      scrollerElement.addEventListener('scrollend', endSettle);
    }
  }

  scrollerElement.addEventListener('pointerdown', (event) => {
    endSettle();

    hasDragged = false;

    if (event.pointerType === 'touch') return;

    if (event.button !== 0) return;

    if (!getIsScrollable(scrollerElement.scrollWidth, scrollerElement.clientWidth)) return;

    isDragging = true;
    startPointerX = event.clientX;
    startScrollLeft = scrollerElement.scrollLeft;
    scrollerElement.classList.add('is-dragging');
  });

  scrollerElement.addEventListener('pointermove', (event) => {
    if (!isDragging) return;

    if (!hasDragged && !getIsDragPastThreshold(startPointerX, event.clientX)) return;

    if (!hasDragged) {
      try {
        scrollerElement.setPointerCapture(event.pointerId);
      } catch (error) {
        console.debug('kl-drag-scroll: could not capture the pointer', { pointerId: event.pointerId, error });
      }
    }

    hasDragged = true;
    scrollerElement.scrollLeft = getScrollLeftForDrag(startScrollLeft, startPointerX, event.clientX);
  });

  scrollerElement.addEventListener('pointerup', endDrag);
  scrollerElement.addEventListener('pointercancel', endDrag);

  scrollerElement.addEventListener('kl-loop-scroll:shift', (event) => {
    const shiftPixels = event.detail?.shiftPixels;

    if (typeof shiftPixels !== 'number') return;

    startScrollLeft += shiftPixels;
  });

  scrollerElement.addEventListener(
    'click',
    (event) => {
      if (!hasDragged) return;

      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  scrollerElement.addEventListener('dragstart', (event) => {
    if (!isDragging) return;

    event.preventDefault();
  });
}

document.querySelectorAll('[data-kl-drag-scroll]').forEach(initDragScroll);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-kl-drag-scroll]').forEach(initDragScroll);
});

document.addEventListener('kl:content:added', (event) => {
  const injectedRoot = event.detail && event.detail.root;

  if (!injectedRoot) return;

  injectedRoot.querySelectorAll('[data-kl-drag-scroll]').forEach(initDragScroll);
});
